import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, error, ...props }, ref) => {
    return (
        (<textarea
            className={cn(
                "flex min-h-[80px] w-full transition rounded-md border-0 text-muted-foreground font-light bg-neutral-100 px-3 py-2 text-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
                'border border-muted-foreground/10 focus:ring-0 focus:border focus:border-foreground/40',
                className,
                error && "border border-error focus-visible:border-error"
            )}
            ref={ref}
            {...props} />)
    );
})
Textarea.displayName = "Textarea"

export { Textarea }
